import { CloseOutlined } from "@ant-design/icons";

import { Button, Modal } from "antd";
import React, { FC } from "react";

import styles from "@/components/Pledge/SummaryModal/SummaryModal.module.css";

interface DownloanModalProps {
  open: boolean;
  onClose?: () => void;
}

const SummaryModal: FC<DownloanModalProps> = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      //   Used `styles` to override AntD's default modal padding inline, which classes can't reliably reset.
      styles={{ content: { padding: 0 } }}
      title={
        <div className={styles.titleGroup}>
          <span className={styles.title}>Summary</span>
          <button className={styles.closeBtn} onClick={onClose}>
            <CloseOutlined />
          </button>
        </div>
      }
      className={styles.otpModal}
      width={600}
    >
      <div className={styles.customTable}>
        <span className={styles.paymentDetails}>Payment Details</span>
        <span className={styles.ticketNumber}>Tickets: 2</span>
      </div>
      <div className={styles.customTableColumn}>
        <span className={styles.tableLabel}>Total Interest</span>
        <span className={styles.tableValue}>80.10</span>
      </div>
      <div className={styles.transactionColumn}>
        <span className={styles.tableLabel}>Transaction Fee</span>
        <span className={styles.tableValue}>72.00</span>
      </div>
      <div className={styles.customTableColumn}>
        <span className={styles.netPayable}>Net Payable</span>
        <span className={styles.payableValue}>S$ 152.10</span>
      </div>
      <div className={styles.buttonGroup}>
        <Button className={styles.applyButton} block>
          Proceed To Pay
        </Button>
      </div>
    </Modal>
  );
};

export default SummaryModal;
